import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { PublicLayout } from "@/components/PublicLayout";
import { Loader } from "@/components/shared";
import { PlansBackdrop, PlansHero, PlanCard, GlowCta } from "@/components/PlanVisuals";
import api from "@/lib/api";

export default function PlansPublic() {
  const [plans, setPlans] = useState(null);
  const reduce = useReducedMotion();
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)).catch(() => setPlans([])); }, []);
  return (
    <PublicLayout>
      <section className="relative overflow-hidden" data-testid="public-plans">
        <PlansBackdrop />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-20">
          <PlansHero eyebrow="Investment Plans" title="The 200 Working Days Plan"
            subtitle="Earn 1% of your original principal every working day (Mon–Fri) for 200 working days — simple ROI, never compounded, principal returned at maturity. Percentages are variable, non-guaranteed and subject to the terms and risk disclosure." />
          {plans === null ? <Loader /> : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center [&>*]:w-full [&>*]:max-w-md lg:[&:has(>:only-child)]:grid-cols-1">
              {plans.map((p, i) => (
                <PlanCard key={p.id} plan={p} index={i} highlight={plans.length > 2 && i === 2}
                  cta={<GlowCta as={Link} to="/signup" testId={`plan-cta-${p.id}`}>Get Started</GlowCta>} />
              ))}
            </div>
          )}
          <motion.p initial={reduce ? false : { opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.2 }}
            className="text-center text-xs text-slate-500 mt-10 max-w-2xl mx-auto">
            Saturdays and Sundays do not count as working days and generate no ROI. Returns are not guaranteed. Digital assets involve significant risk of loss.
          </motion.p>
        </div>
      </section>
    </PublicLayout>
  );
}
